<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<Header @custom-event="getToken"></Header>
		<div class="page_content">
			
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/tw/">首頁</a><span class="space">/</span><a href="/tw/user/index">我的帳戶</a><span class="space">/</span>支付通知
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->
			
			<!--页面内容-开始-->
			<div class="booking_success_box">
				<div v-if="payStatus==1">
					<h1>支付成功</h1>
					<h5>
						如需幫助請致電：1-808-921-9999 或發送郵件至： info@hawaiiglobalholiday.com
					</h5>
					<div class="pay_result_img"></div>
					<div class="btns">
						<!-- <div class="btn blue"><a :href="'/tw/user/orders'">查看全部账单</a></div> -->
						<div class="btn hollow"><a href="/tw/user/index">返回我的帳戶</a></div>
					</div>
				</div>
				<div v-else style=" padding: 200px 0;">
					<h1>錯誤：{{errMessage}}</h1>
				</div>
			</div>
			<!--页面内容-结束-->
			
		</div>
		<Footer></Footer>
	</div>
</template>


<script>
	import {
		checkToken,
		getOrderDetail,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import Header from '@/components/tw_header.vue'
	import Footer from '@/components/tw_footer.vue'
	export default {
		name: 'TW_UserPayResult',
		mixins: [mixin],
		components: {
			Header,
			Footer,
		},
		data() {
			return {
				orderNo: null,	//订单编号
				errMessage: '非正常加载页面',	//报错原因
				payStatus:'',	//支付状态，0:失败，1:成功
				orderType:'',	//订单类型，值为py时代表是协议订单，为空时代表普通和批量支付
				
				
				fullscreenLoading: false, //loading状态
				language: 'tw', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token				
			}
		},
		created() {
			
			// 获取orderNo
			if (this.$route.query.OrderNo != undefined && this.$route.query.OrderNo !='') {
				this.orderNo = this.$route.query.OrderNo
			}
			
			// 获取Status
			if (this.$route.query.Status != undefined && this.$route.query.Status !='') {
				this.payStatus = this.$route.query.Status
			}
			
			// 获取errMessage
			if (this.$route.query.Msg != undefined && this.$route.query.Msg !='') {
				this.errMessage = this.$route.query.Msg
			}
			
			// 获取orderType
			if (this.$route.query.Type != undefined && this.$route.query.Type !='') {
				this.orderType = this.$route.query.Type
			}
			
			console.log(this.payStatus)
		},
		methods: {
			//接收组件回传Token
			getToken(token)
			{
				this.token = token
				if(this.token !=null && this.token !='')
				{
					this.loginStatus = true
				}
				else				
				{
					this.$router.push({
						path: '/tw/user/login'
					})
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;


	}
</style>